<template>
    <div>
        <button type="button" class="btn btn-sm btn-outline-secondary" id="changeCustodyModalButton" @click="openModal">
            <i class="fa-solid fa-people-arrows"></i> {{ $t('button_change_assign') }}
        </button>

        <div v-if="isModalOpen" class="modal fade text-start" id="changeCustodyModal" tabindex="-1"
            aria-labelledby="changeCustodyModalLabel" aria-hidden="true" style="display: block;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="block-rounded block-$tparent mb-0 block">
                        <div class="block-header block-header-default">
                            <h3 class="block-title">{{ $t('button_assign_to_other_user') }}</h3>
                            <div class="block-options">
                                <button type="button" class="btn-block-option" @click="closeModal">
                                    <i class="fa fa-fw fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content mb-4">
                            <label class="form-label" for="assigned_to_input">{{ $t('input_assigned_to') }}</label>
                            <div class="d-flex">
                                <select v-model="assignedTo" required name="assigned_to_input" id="assigned_to_input"
                                    class="selectpicker show-menu-arrow" data-style="btn-alt-secondary"
                                    data-select-all-headers="true" data-size="5" data-selected-text-format="count > 4"
                                    data-width="100%" data-actions-box="true" data-live-search="true">
                                    <option value="" hidden disabled>{{ $t('input_select_from') }}</option>
                                    <optgroup v-for="(users, role) in grouped_users" :label="capitalize(role)" :key="role">
                                        <option v-for="user in users" :key="user._id" :value="user._id"
                                            :data-tokens="user.first_name">
                                            {{ user.first_name }} {{ user.last_name }}
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                        <input type="hidden" v-model="shipmentId">
                        <div class="block-content block-content-full bg-body text-end">
                            <button type="button" class="btn btn-sm btn-alt-secondary me-1" @click="closeModal">{{ $t('button_cancel') }}</button>
                            <button type="button" class="btn btn-sm btn-primary" @click="submitForm">{{ $t('button_submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue';

export default {
    props: {
        grouped_users: {
            type: Object,
            required: true,
            default: () => ({})
        },
        selectedShipments: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            isModalOpen: false,  // Controls modal visibility
            assignedTo: '',  // Stores selected user ID
            shipmentId: '',  // Stores the shipment ID
        };
    },
    methods: {
        // Method to open the modal and set the groupedUsers and selectedShipments
        openModal() {
            if (Object.keys(this.selectedShipments).length > 0) {
                // If there are selected shipments, get the first one to set shipmentId
                const firstShipment = this.selectedShipments[Object.keys(this.selectedShipments)[0]];
                this.shipmentId = firstShipment._id; // Assuming shipment ID is _id
                // Automatically assign the user ID of the first selected shipment to the select field
                this.assignedTo = firstShipment.assigned_to || ''; // If no assigned_to, leave empty
            }

            console.log('Selected Shipments:', this.assignedTo);

            this.isModalOpen = true;

            nextTick(() => {
                this.initializeSelectpicker();
            });
        },
        // Method to close the modal
        closeModal() {
            this.isModalOpen = false;
            this.assignedTo = ''; // Reset the selected user when closing
            nextTick(() => {
                this.destroySelectpicker();
            });
        },
        // Method to handle the form submission
        submitForm() {
            if (this.assignedTo) {
                // Handle the form submission here, e.g., call an API to assign the user
                console.log('Assigned to:', this.assignedTo);
                console.log('Shipment ID(s):', this.shipmentId);

                // Close the modal after submission
                this.closeModal();
            } else {
                // Handle validation or error message if no user is selected
                alert('Please select a user to assign.');
            }
        },
        // Helper method to capitalize the role name
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        // Initialize selectpicker after modal opens
        initializeSelectpicker() {
            // Assuming jQuery is available for selectpicker
            $('#assigned_to_input').selectpicker('refresh');
        },
        // Destroy selectpicker when modal closes
        destroySelectpicker() {
            // Clean up selectpicker to avoid memory leaks
            $('#assigned_to_input').selectpicker('destroy');
        }
    }
};
</script>

<style scoped>
/* You can add styles here if needed */
</style>
